export const setDeviceId = (deviceId) => {
  localStorage.setItem("bId", deviceId);
};

export const getDeviceId = () => {
  return localStorage.getItem("bId") || null;
};

export const removeDeviceId = () => {
  localStorage.removeItem("bId");
};
